export const getDeviceType = () => {
  if (typeof navigator === 'undefined') return 'desktop';
  
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  
  // iOS detection
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
    return 'ios';
  }
  
  // Android detection
  if (/android/i.test(ua)) {
    return 'android';
  }
  
  return 'desktop';
};